export const setDropdownState = (index: number, dropdownState: boolean) => {
  return (prevState: boolean[]) => {
    const newVal = [...prevState.map(() => false)];
    newVal[index] = !dropdownState;
    return newVal;
  };
};
